"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";
import { getAssetUrl } from "@/utils/assetUrl";

interface ErrorScreenProps {
  titleKey?: string;
  messageKey?: string;
}

export default function ErrorScreen({
  titleKey = "title",
  messageKey = "message",
}: ErrorScreenProps) {
  const t = useTranslations("error-screen");

  return (
    <div className="error-screen" role="alert">
      <div className="error-screen-icon">
        <Image
          src={getAssetUrl("/images/sad_face.svg")}
          alt=""
          fill
          sizes="10rem"
          aria-hidden
          unoptimized
        />
      </div>
      <h1 className="error-screen-title">{t(titleKey)}</h1>
      <p className="error-screen-message">{t(messageKey)}</p>
    </div>
  );
}
